<template>
  <div id="user-group-to-party-group">
    <div class="white-bg shadow">
      <blockquote>Party Groups</blockquote>
      <h4>Select a PartyGroup to add</h4>
      <div class="input-group">
        <select class="form-control" v-model="partyGroup">
          <option :value="null"></option>
          <option v-for="pg in availablePartyGroups" :value="pg.id">
            {{ pg.name }}
          </option>
        </select>
        <div class="input-group-btn">
          <button class="btn btn-primary sq" @click.stop="add">
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
      <ul class="list-group">
        <li class="list-group-item clearfix" v-for="pg in partyGroups">
          {{ pg.partyGroup && pg.partyGroup.name }}
          <div class="pull-right">
            <div class="btn btn-danger" @click="remove(pg.id)">
              <i class="fa fa-times"></i>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import API from '../../../../api/endpoints.js'
  export default {
    name: 'UserGroupToPartyGroup',
    props: {
      userGroupId: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        partyGroup: [],
        partyGroups: []
      }
    },
    computed: {
      availablePartyGroups () {
        const inUsePartyGroups = this.partyGroups.map(({partyGroup}) => partyGroup && partyGroup.id)
        return this.$store.getters['systemOption/partyGroups'].filter(({id}) => !inUsePartyGroups.includes(id))
      }
    },
    methods: {
      getPartyGroups () {
        this.$http.get(API.GET_ENTITIES('user-group-to-party-group'), {
          params: { userGroup: this.userGroupId },
          headers: { 'X-Lazy-Fetch': '0' }
        }).then(({data}) => { this.partyGroups = data })
      },
      add () {
        this.$http.post(API.CREATE_ADMIN_ENTITY('user-group-to-party-group'), {
          userGroup: this.userGroupId,
          partyGroup: this.partyGroup
        }).then(({data}) => { this.partyGroups.push(data) })
      },
      remove (_id) {
        const i = this.partyGroups.findIndex(({id}) => id === _id)
        this.$http.delete(API.DELETE_ADMIN_ENTITY('user-group-to-party-group', _id))
          .then(() => {
            if (i > -1) {
              this.partyGroups.splice(i, 1)
            }
          })
      }
    },
    mounted () {
      this.getPartyGroups()
    }
  }
</script>



// WEBPACK FOOTER //
// src/modules/admin/components/UserGroup/UserGroupToPartyGroup.vue